import { showModal } from '@/scripts/utils/base';

/**
 * @typedef {{
 *    title: string,
 *    msg: string,
 *    okText: string,
 * }} Config
 */

/** @type {Config} */
const DEF_CONFIG = {
   title: '',
   msg: '',
   okText: 'Ok',
};

/** @type {AlertModal} */
let alertModal = null;

export default class AlertModal {
   constructor() {
      if (alertModal) return alertModal;
      alertModal = this;

      this._modalId = 'alert-modal';
      this.$root = document.querySelector(`#${this._modalId}`);

      this._init();
   }

   _init() {
      this._getElements();
   }

   /** 
    * @param {Config} config
    * @param {import('micromodal').MicroModalConfig} micromodalConfig
    * @returns {Promise<void>}
    */
   show(config, micromodalConfig = {}) {
      return new Promise((resolve) => {
         this._render(config);

         showModal(this._modalId, {
            ...micromodalConfig,
            async onClose() {
               if (micromodalConfig.onClose) await micromodalConfig.onClose();
               resolve();
            },
         });
      });
   }

   /** @param {Config} config */
   _render(config) {
      config = { ...DEF_CONFIG, ...config };
      const { title, msg, okText } = config;

      this.$title.innerHTML = title;
      this.$msg.innerHTML = msg;
      this.$okBtn.innerHTML = okText;
   }

   _getElements() {
      this.$title = this.$root.querySelector('.title-js');
      this.$msg = this.$root.querySelector('.msg-js');
      this.$okBtn = this.$root.querySelector('.ok-btn-js');
   }
}